// eslint-disable-next-line import/prefer-default-export
export const TRIAL_DAYS_INIT = 14;
